import React from 'react'
import { clsx } from 'clsx'

interface BadgeProps {
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info' | 'processing' | 'primary' | 'secondary'
  size?: 'sm' | 'md' | 'lg'
  children: React.ReactNode
  className?: string
}

export const Badge: React.FC<BadgeProps> = ({
  variant = 'default',
  size = 'md',
  children,
  className
}) => {
  const baseClasses = 'inline-flex items-center font-medium rounded-full'
  
  const variantClasses = {
    default: 'bg-gray-100 text-gray-800',
    success: 'bg-green-100 text-green-800',
    warning: 'bg-yellow-100 text-yellow-800',
    error: 'bg-red-100 text-red-800',
    info: 'bg-blue-100 text-blue-800',
    processing: 'bg-purple-100 text-purple-800',
    primary: 'bg-blue-500 text-white',
    secondary: 'bg-gray-500 text-white'
  }
  
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-0.5 text-sm',
    lg: 'px-3 py-1 text-base'
  }

  return (
    <span
      className={clsx(
        baseClasses,
        variantClasses[variant],
        sizeClasses[size],
        className
      )}
    >
      {children}
    </span>
  )
}

// Helper function to get badge variant based on article status
export const getStatusBadgeVariant = (status: string): BadgeProps['variant'] => {
  switch (status) {
    case 'fetched':
      return 'default'
    case 'expanded':
      return 'info'
    case 'summarised':
      return 'processing'
    case 'pushed_to_hubspot':
      return 'success'
    case 'failed_expansion':
    case 'failed_summary':
    case 'failed_push':
      return 'error'
    default:
      return 'default'
  }
} 